import React from 'react';
import './CaseStudiesSection.css';

const caseStudies = [
  {
    name: 'Rahul',
    story: 'Saved ₹10,000 on his new phone – Here’s how.',
    image: 'https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortCurly&accessoriesType=Sunglasses&clotheType=Hoodie&clotheColor=Blue03&skinColor=Light',
    before: 'Paid full price at a retail store.',
    after: 'Used DiscountDost to find the best deal and got cashback.',
  },
  {
    name: 'Anjali',
    story: 'Secured a premium spa experience at half price – See her story.',
    image: 'https://avataaars.io/?avatarStyle=Circle&topType=LongHairStraight&accessoriesType=Round&clotheType=BlazerShirt&clotheColor=PastelBlue&skinColor=Brown',
    before: 'Booked spa visits without discounts.',
    after: 'Used our spa partner offer & paid just 50%.',
  },
];

const CaseStudiesSection = () => {
  return (
    <div className="case-studies-section">
      <h2>Real Stories. Real Savings.</h2>
      <div className="case-studies-grid">
        {caseStudies.map((caseStudy, index) => (
          <div className="case-card" key={index}>
            <img src={caseStudy.image} alt={`${caseStudy.name}'s story`} />
            <div className="case-content">
              <h3>{caseStudy.story}</h3>
              <p><strong>Before:</strong> {caseStudy.before}</p>
              <p><strong>After:</strong> {caseStudy.after}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CaseStudiesSection;
